/**
 * Attribution légale obligatoire des sources de données cartographiques Terravision.
 *
 * Terravision réutilise des données sous licences qui imposent une attribution :
 * - IGN (BD TOPO, OCS GE, fond de plan Géoplateforme) — Licence Ouverte 2.0 (Etalab).
 * - OpenStreetMap (réseau piéton/POIs via osmnx) — licence ODbL : attribution obligatoire.
 * - BDNB (DPE, caractéristiques bâtiments) — © CSTB.
 * - Cadastre (parcelles) — © DGFiP, diffusé via Etalab.
 *
 * Ce module est la seule source de vérité pour ce texte : toute carte MapLibre du
 * frontend doit importer `DataAttribution` (composant) ou, à défaut, réutiliser
 * `DATA_SOURCE_ATTRIBUTIONS` pour rester cohérente. Voir docs/DATA_SOURCES.md.
 */
export const DATA_SOURCE_ATTRIBUTIONS = [
  '© IGN — Licence Ouverte 2.0',
  "© les contributeurs d'OpenStreetMap (ODbL)",
  'BDNB © CSTB',
  'Cadastre © DGFiP/Etalab',
] as const;

/** Texte concaténé, utile pour les usages hors contrôle MapLibre (ex. tests, pied de page). */
export const DATA_ATTRIBUTION_TEXT = DATA_SOURCE_ATTRIBUTIONS.join(' · ');
